import React, { FC, useCallback, useState } from 'react';
import { Stack } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';
import { ModalTabProps } from '../../models/reusableProps/ModalTabProps';
import { returnTabConfig } from './utils';
import CustomTabsComponent from '../CustomTabsComponent';
import CustomTabsPanelComponent from '../CustomTabsPanelComponent';
import ProjectDirectiveView from '../ProjectDirectiveView';
import { useFormContext } from 'react-hook-form';
import { checkForConfidential } from '../../containers/App/utils';
import { useTypedSelector } from '../../store';
import { selectUserRole } from '../../store/userData/selectors';

const CloseProjectTabs: FC<ModalTabProps> = ({
  projectsList,
  currentProject,
  countries,
  setActiveProject,
  usersList,
  BuList,
  isConfidentialAllowed,
  isEdit,
  onCountryChange,
  onBUChange,
  tabErrors,
  directiveOpen,
  onShowDirective,
  onHideDirective,
}) => {
  const t = useTranslation();
  const [activeTab, setActiveTab] = useState('Required');
  const handleTabChange = (e, newValue) => {
    setActiveTab(newValue);
  };

  const handleEditField = useCallback(
    (tab: string, fieldName: string) => {
      onHideDirective?.();
      setActiveTab(tab);
      if (fieldName) {
        setTimeout(() => {
          const el =
            document.getElementById(fieldName) ??
            document.getElementById(`${fieldName}-select`) ??
            document.getElementById(`${fieldName}-id`);
          if (el) {
            el.focus();
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 300);
      }
    },
    [onHideDirective],
  );
  const { watch } = useFormContext();
  const confidential = watch('confidential');
  const userRole = useTypedSelector(selectUserRole);
  const tabsConfig = returnTabConfig(
    t,
    currentProject,
    countries,
    projectsList,
    setActiveProject,
    usersList,
    BuList,
    isConfidentialAllowed,
    isEdit,
    onCountryChange,
    currentProject?.isep,
    onBUChange,
    null,
    checkForConfidential(confidential),
    userRole,
    onShowDirective,
  );

  if (directiveOpen) {
    return (
      <Stack>
        <ProjectDirectiveView
          project={currentProject}
          onEditField={handleEditField}
        />
      </Stack>
    );
  }

  return (
    <Stack>
      <CustomTabsComponent
        activeTab={activeTab}
        onTabChange={handleTabChange}
        tabList={tabsConfig.tabList}
        tabErrors={tabErrors}
      />
      <CustomTabsPanelComponent
        activeTab={activeTab}
        panelsList={tabsConfig.panelsList}
      />
    </Stack>
  );
};

export default CloseProjectTabs;
